import ApiClient from "griptonite-api-client";

import config from "../config";

const api = new ApiClient({
  baseUrl: config.API_BASE_URL,
  clientId: config.CLIENT_ID,
  clientSecret: config.CLIENT_SECRET,
  getToken: () => {
    const t = localStorage.getItem("auth.token");
    if (!t) {
      return null;
    }
    const data = JSON.parse(t);
    return data.accessToken;
  },
});
export default api;
